/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.lendMaster.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
